import { Trans, t } from "@lingui/macro";

import { useAuth } from "context/AuthContext/AuthProvider";
import { useENS, shortenAddress } from "lib/legacy";
import useWallet from "lib/wallets/useWallet";

import { Avatar } from "components/Avatar/Avatar";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";

import "./SignInModal.scss";

export function SignInModal() {
  const { account } = useWallet();
  const { ensName } = useENS(account);
  const { isSignInModalOpen, setSignInModalOpen, isSigningIn, authError, signIn } = useAuth();

  return (
    <Modal
      className="SignInModal"
      isVisible={isSignInModalOpen}
      setIsVisible={setSignInModalOpen}
      label={t`Verify your wallet`}
      description={t`One quick signature to finish signing in`}
      zIndex={80}
      contentClassName="SignInModal-content"
    >
      <div className="SignInModal-body">
        <div className="SignInModal-hero">
          <div className="SignInModal-heroIcon" aria-hidden>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path
                d="M7 10V8a5 5 0 0 1 10 0v2"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <rect x="4" y="10" width="16" height="11" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
              <circle cx="12" cy="15.5" r="1.4" fill="currentColor" />
            </svg>
          </div>
          <p className="SignInModal-lead">
            <Trans>
              Confirm ownership of this wallet with a free signature. No transaction is sent and no gas is charged.
            </Trans>
          </p>
        </div>

        {account ? (
          <div className="SignInModal-walletCard">
            <Avatar size={36} address={account} ensName={ensName} />
            <div className="SignInModal-walletMeta">
              <span className="SignInModal-walletLabel">
                <Trans>Connected wallet</Trans>
              </span>
              <span className="SignInModal-walletAddress">{ensName || shortenAddress(account, 17)}</span>
            </div>
          </div>
        ) : null}

        <ol className="SignInModal-steps">
          <li>
            <Trans>Click Sign message below</Trans>
          </li>
          <li>
            <Trans>Approve the request in your wallet</Trans>
          </li>
          <li>
            <Trans>You're signed in — start trading</Trans>
          </li>
        </ol>

        {authError ? (
          <div className="SignInModal-error" role="alert">
            {authError}
          </div>
        ) : null}

        <Button
          variant="primary-action"
          className="SignInModal-button w-full"
          disabled={isSigningIn || !account}
          onClick={() => {
            void signIn();
          }}
        >
          {isSigningIn ? <Trans>Waiting for wallet signature...</Trans> : <Trans>Sign message</Trans>}
        </Button>

        <button
          type="button"
          className="SignInModal-skip"
          disabled={isSigningIn}
          onClick={() => setSignInModalOpen(false)}
        >
          <Trans>Not now</Trans>
        </button>
      </div>
    </Modal>
  );
}
